/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-else-return */
import React, { FC, useEffect, useState } from 'react';
import i18n from 'i18next';
import { registerLocale } from 'react-datepicker';
import moment from 'moment';
import de from 'date-fns/locale/de';
import ca from 'date-fns/locale/ca';
import en from 'date-fns/locale/en-US';
import eu from 'date-fns/locale/eu';
import gl from 'date-fns/locale/gl';
import es from 'date-fns/locale/es';
import { useTranslation } from 'react-i18next';
import { CompraService } from '../../services';
import useAPIError from '../../hooks/useAPIError';
import { useAuthStore } from '../../store/AuthContext';
import { useAppStore } from '../../store/AppContext';
import { CompraData } from '../../types/Types';

import useDatalayerEvents from '../../hooks/useDatalayerEvents';
import useSessionChecking from '../../hooks/useSessionChecking';
import { BackMappings } from '../../utils/BackMappings';
import { GtmConstants } from '../../utils/GtmConstants';
import { StorageHelper } from '../../utils/StorageHelper';
import NotFound from '../NotFound';
import ComprasTicketCaprabo from './indexCaprabo';
import ComprasTicketEroski from './indexEroski';
import { HostProvider } from '../../utils/HostProvider';

const ComprasTicket: FC = () => {
  const { t } = useTranslation();

  const isCaprabo = HostProvider.isCaprabo();
  const isEroski = HostProvider.isEroski();
  const [goOn, setGoOn] = useState<boolean>(false);
  StorageHelper.setOrigin(BackMappings.COMPRAS);
  useSessionChecking(BackMappings.COMPRAS, setGoOn, goOn);
  useDatalayerEvents(GtmConstants.MI_CUENTA);

  const [compraData, setCompraData] = useState<CompraData[]>([]);
  const [totalElements, setTotalElements] = useState(0 as number);
  const [load, setLoad] = useState(false as boolean);
  const [view, setView] = useState(false as boolean);
  const dataApp = useAppStore();
  const { addError, addErrorBack } = useAPIError();
  const [visible, setVisible] = useState(false as boolean);
  const [backErrorCompras, setBackErrorCompras] = useState(false as boolean);
  const [backErrorOption, setBackErrorOption] = useState(false as boolean);
  const [activo, setActivo] = useState(false as boolean);
  const dataUser = useAuthStore();
  const [startDate, setStartDate] = useState<any>(null);
  const [endDate, setEndDate] = useState<any>(null);
  const [firstCharge, setFirstCharge] = useState(true);
  const [firstCharge2, setFirstCharge2] = useState(true);

  const retrieveCompra = () => {
    const data = {
      pageNumber: 1,
      fromDate:
        startDate === null ? startDate : moment(startDate).format('DD/MM/YYYY'),
      toDate: endDate === null ? endDate : moment(endDate).format('DD/MM/YYYY'),
    };
    CompraService.retrieveCompra(data)
      .then((response) => {
        if (response.data.error === true) {
          if (
            firstCharge &&
            response.data.errorCode !== BackMappings.GO_TO_RELOGIN
          ) {
            addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
          }
          setView(true);
          setBackErrorCompras(true);
          addErrorBack(response.data);
        } else {
          setFirstCharge(false);
          setLoad(true);
          setBackErrorCompras(false);
          setView(true);
          if (typeof response.data.pojos !== 'undefined')
            setCompraData(response.data.pojos);
          if (typeof response.data.totalElements !== 'undefined')
            setTotalElements(response.data.totalElements);
        }
      })
      .catch((e) => {
        console.log(e);
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
      });
  };

  const retrieveCompraByDates = (page = 1) => {
    const data = {
      pageNumber: page,
      fromDate:
        startDate === null ? startDate : moment(startDate).format('DD/MM/YYYY'),
      toDate: endDate === null ? endDate : moment(endDate).format('DD/MM/YYYY'),
    };

    CompraService.retrieveCompraByDates(data)
      .then((response) => {
        if (response.data.error === true) {
          setView(true);
          setBackErrorCompras(true);
          addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
        } else {
          setLoad(true);
          setBackErrorCompras(false);
          setView(true);
          if (typeof response.data.pojos !== 'undefined')
            setCompraData(response.data.pojos);
          if (typeof response.data.totalElements !== 'undefined')
            setTotalElements(response.data.totalElements);
        }
      })
      .catch((e) => {
        console.log(e);
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
      });
  };

  const retrivePapelOptionState = () => {
    CompraService.ticketPapelState()
      .then((response) => {
        if (response.data.error === true) {
          if (
            firstCharge2 &&
            response.data.errorCode !== BackMappings.GO_TO_RELOGIN
          ) {
            addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
          }
          setBackErrorOption(true);
          addErrorBack(response.data);
        } else {
          setActivo(response.data.activo);
          setBackErrorOption(false);
        }
        setFirstCharge2(false);
      })
      .catch((e) => {
        console.log(e);
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
      });
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (dataUser.user.token !== '') {
      if (!load) {
        setLoad(true);
        retrieveCompra();
        retrivePapelOptionState();
      }
    }
  });

  useEffect(() => {
    if (dataUser.user.token !== '') {
      retrieveCompra();
      retrivePapelOptionState();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language]);

  useEffect(() => {
    switch (dataApp.lang) {
      case 'de':
        registerLocale('lang', de);
        moment.locale('de');
        break;
      case 'ca':
        registerLocale('lang', ca);
        moment.locale('ca');
        break;
      case 'en':
        registerLocale('lang', en);
        moment.locale('en');
        break;
      case 'eu':
        registerLocale('lang', eu);
        moment.locale('eu');
        break;
      case 'gl':
        registerLocale('lang', gl);
        moment.locale('gl');
        break;
      default:
        registerLocale('lang', es);
        moment.locale('es');
    }
  }, [dataApp.lang]);

  if (goOn) {
    if (view) {
      if (isEroski) {
        return (
          <>
            <ComprasTicketEroski
              dataApp={dataApp}
              activo={activo}
              visible={visible}
              setActivo={setActivo}
              setVisible={setVisible}
              backErrorCompras={backErrorCompras}
              backErrorOption={backErrorOption}
              retrieveCompraByDates={retrieveCompraByDates}
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
              compraData={compraData}
              totalElements={totalElements}
            />
          </>
        );
      } else if (isCaprabo) {
        return (
          <>
            <ComprasTicketCaprabo
              dataApp={dataApp}
              activo={activo}
              visible={visible}
              setActivo={setActivo}
              setVisible={setVisible}
              backErrorCompras={backErrorCompras}
              backErrorOption={backErrorOption}
              retrieveCompraByDates={retrieveCompraByDates}
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
              compraData={compraData}
              totalElements={totalElements}
            />
          </>
        );
      }
      return <NotFound />;
    }
    return <></>;
  }
  return <></>;
};

export default ComprasTicket;
